import Navbar from 'react-bootstrap/Navbar';
import React from 'react';
import { 
    NavbarContainer,
    NavbarMenu,
    NavbarFlex,
    NavLink,
    ContainerExtend,
    TabDiv,
    ActiveBox
 } from "./style"
 import Logo from '../../image/Sequoia-logo_gold.png'
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useWindowSize } from '../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

const StyledNav = styled.nav`
  position: fixed;  // Makes the navbar stick to the viewport
  top: 0;          // Positions at the top
  left: 0;         // Ensures full width alignment
  right: 0;        // Ensures full width alignment
  width: 100%;     // Full width
  z-index: 1000;   // Ensures navbar stays above other content
  background-color: #fff;  // Or your desired background color
`;

const NavigationBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation('common');


  return (
    <StyledNav>
      <NavbarContainer expand="lg">
        <ContainerExtend>
          <Navbar.Brand href="/">
              <img
                width='154px'
                height='auto'
                src={Logo} 
                alt="logo" 
              />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <NavbarMenu id="basic-navbar-nav">
            <NavbarFlex>
              <NavLink href="/">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/'}
                  > 
                    {t('nav.home').toUpperCase()} 
                  </ActiveBox>
                ) : (
                  <TabDiv 
                    isActive={currentPath === '/'}
                  >
                    {t('nav.home')}
                  </TabDiv> 
                )}
              </NavLink>
              <NavLink href="/practice-area">
                {width > 992 ? (
                  <ActiveBox isActive={currentPath === '/practice-area'}>
                    {t('nav.practiceArea').toUpperCase()}
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/practice-area'}>{t('nav.practiceArea')}</TabDiv> 
                )}
              </NavLink>
              <NavLink href="/our-team">
                {width > 992 ? (
                  <ActiveBox isActive={currentPath === '/our-team'}>
                    {t('nav.ourTeam').toUpperCase()}
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/our-team'}>{t('nav.ourTeam')}</TabDiv> 
                )}
              </NavLink>
              <NavLink href="/article-news">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/article-news'}
                  >
                    {t('nav.articleNews').toUpperCase()}
                  </ActiveBox>
                ) : (
                    <TabDiv 
                      isActive={currentPath === '/article-news'}
                    >
                      {t('nav.articleNews')}
                    </TabDiv> 
                )}
              </NavLink>
              <NavLink href="/contact">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/contact'}
                  >
                    {t('nav.contact').toUpperCase()}
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/contact'}>{t('nav.contact')}</TabDiv> 
                )}
              </NavLink>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 12 }}>
                <div 
                  onClick={() => i18n.changeLanguage('en')} 
                  style={{ 
                    background: 'transparent', 
                    borderRadius: 8, 
                    padding: '6px 10px', 
                    cursor: 'pointer',
                    fontWeight: i18n.language === 'en' ? 'bold' : 'normal'
                  }}
                >
                  <div style={{ color: i18n.language === 'en' ? '#000000' : '#FFCC79' }}>EN</div>
                </div>
                <div style={{ color: '#FFCC79', margin: '0 4px' }}>|</div>
                <div 
                  onClick={() => i18n.changeLanguage('id')} 
                  style={{ 
                    background: 'transparent', 
                    borderRadius: 8, 
                    padding: '6px 10px', 
                    cursor: 'pointer',
                    fontWeight: i18n.language === 'id' ? 'bold' : 'normal'
                  }}
                >
                  <div style={{ color: i18n.language === 'id' ? '#000000' : '#FFCC79' }}>ID</div>
                </div>
              </div>
            </NavbarFlex>
          </NavbarMenu>
        </ContainerExtend>
      </NavbarContainer>
    </StyledNav>
  );
}

export default NavigationBar;